import { QueryKey } from '@shared/config';
import type {
  CandidateProcessRequestParams,
  CandidateRequestParams,
} from '../types';

export const candidateQueryKeys = {
  all: [QueryKey.GET_CANDIDATES] as const,
  lists: () => candidateQueryKeys.all,
  list: (
    params: CandidateRequestParams
  ): [QueryKey.GET_CANDIDATES, CandidateRequestParams] => [
    QueryKey.GET_CANDIDATES,
    params,
  ],
  detail: (candidateId: string | number) =>
    [QueryKey.GET_CANDIDATE, candidateId.toString()] as const,
  statuses: [QueryKey.GET_CANDIDATE_STATUSES] as const,
  resume: (candidateId: string | number, resumeId: string | number) =>
    [
      'candidate-resume',
      {
        candidateId: candidateId.toString(),
        resumeId: resumeId.toString(),
      },
    ] as const,
  allResumes: (candidateId: string | number): [string] => [
    `candidate-resumes-${candidateId}`,
  ],
  resumes: (
    candidateId: number,
    params: CandidateRequestParams
  ): [string, CandidateRequestParams] => [
    ...candidateQueryKeys.allResumes(candidateId),
    params,
  ],
  // Chat history keys include the mounted chat session: its request markers
  // must not mix with cached observations of an earlier session.
  processesRoot: (candidateId: string) =>
    [QueryKey.GET_CANDIDATE_PROCESSES, candidateId] as const,
  processes: (
    candidateId: string,
    params: CandidateProcessRequestParams,
    sessionId: string
  ) =>
    [QueryKey.GET_CANDIDATE_PROCESSES, candidateId, params, sessionId] as const,
  processesRefreshRoot: (candidateId: string) =>
    [QueryKey.GET_CANDIDATE_PROCESSES_REFRESH, candidateId] as const,
  processesRefresh: (
    candidateId: string,
    params: CandidateProcessRequestParams,
    sessionId: string
  ) =>
    [
      QueryKey.GET_CANDIDATE_PROCESSES_REFRESH,
      candidateId,
      params,
      sessionId,
    ] as const,
};

export const candidateMutationKeys = {
  updateResume: ['update-candidate-resume'] as const,
  updateStatus: ['update-candidate-status'] as const,
  changeResumeActivity: ['change-candidate-resume-activity'] as const,
};
